var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"opening__times"},[_vm._v("\n  "+_vm._s(_vm.getMessage)+"\n  "),_c('span',{class:_vm.isOpen ? '_is-open' : '_is-closed'})])}
var staticRenderFns = []

export { render, staticRenderFns }